/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { get, CreateIntegerRange, GetColourArray, extractRefsFromSVG } from "../../components/Common";
import { makeStyles } from "@material-ui/core/styles";
import * as Paper from "../layout/PaperFunctions";
import { Palette } from "../../AppConfig";
import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_Select from "../../components/BSL_Select";
import BSL_ColourSelector from "../../components/BSL_ColourSelector";
import BSL_TextInput from "../../components/BSL_TextInput";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import {
    updateAreaSpecification,
    updateAreaSpecificationBeamPost,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import {
    Check_corner_post_must_be_90_for_hip,
    PostTypeTopConnectionAllowed,
    validateRHSBeamLength,
    validateRHSPostFooting,
} from "../../redux_store/jobState_Validation";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import BSL_Button from "../../components/BSL_Button";
import { ListSubheader, Tooltip } from "@material-ui/core";
import BSL_CheckBox from "../../components/BSL_CheckBox";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CrossCircleIcon from "@material-ui/icons/Cancel";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CachedIcon from "@material-ui/icons/Cached";
import SpecExtraBeamDialog from "../context_options/SpecExtraBeamDialog";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: "0px 8px 8px 8px",
    },
    cutoutSummary: {
        color: "white",
        fontSize: "70%",
    },
    paper_root: {
        background: "#090909ad",
    },
    header_fail: {
        display: "flex",
        alignItems: "center",
        alignSelf: "flex-start",
        color: "#bd1414",
    },
    header_pass: {
        display: "flex",
        alignItems: "center",
        alignSelf: "flex-start",
        color: "#008200",
    },
    header_warning: {
        display: "flex",
        alignItems: "center",
        alignSelf: "flex-start",
        color: "#a66b00",
    },
    header_unknown: {
        display: "flex",
        alignItems: "center",
        alignSelf: "flex-start",
        color: "#b37f0b",
    },
    label: {
        flex: "1",
        font: (theme.brand.FIELDERS ? "12pt " : "11pt ") + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
        textAlign: "start",
    },
    result_item: {
        marginLeft: "5px",
        paddingTop: "3px",
    },
}));

export const check_cyclonic = (config, key, is_cyclonic) => {
    if (is_cyclonic) {
        if (Array.isArray(config)) {
            if (config?.includes(key)) {
                return true;
            }
        }
        if (config?.length > 0) {
            if (config === key) {
                return true;
            }
        }
    }
    return false;
};

export function get_beam_menu_items(config, job, beamTypeID, areaIndex, is_cyclonic, rafterBeam, length = 0) {
    const { GABLE_PORTAL, PITCHED } = CONFIG.DESIGN_TYPES;

    const areaSpecs = job?.AreaSpecifications?.[areaIndex];
    const designTemplate = areaSpecs?.SHAPE?.DesignTemplateType; // e.g National Carport
    const designType = areaSpecs?.SHAPE?.DesignType; // e.g flat roof
    const hasHiporDutch = areaSpecs?.SHAPE?.RoofType1 !== "Gable" || areaSpecs?.SHAPE?.RoofType2 !== "Gable";
    const isFlat = ![GABLE_PORTAL, PITCHED].includes(designType);
    const hasRidgeBeam = areaSpecs?.BEAMS_AND_POSTS?.HasRidgeBeam === 1;
    const BeamAndPostParams = areaSpecs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS];

    let last_area_data = job?.AreaSpecifications?.[areaIndex - 1];
    let this_area_data = job?.AreaSpecifications?.[areaIndex];
    let next_area_data = job?.AreaSpecifications?.[areaIndex + 1];
    let is_part_of_hip_junction = false;
    if (
        (next_area_data && this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Hip") ||
        (last_area_data && last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Hip")
    ) {
        is_part_of_hip_junction = true;
    }

    // Config values
    const designOptions = config?.design_options?.[designTemplate || designType];
    const beamTypeNum = `beam_${beamTypeID}`;
    const beamType = `BeamType${beamTypeID}`;
    const allBeamDisplayDetails = config.beam_types;
    const maxLengthRHS = 8000;

    let beamMenuItems = [];

    // Special case for Fielders gable fascia beam
    if (beamTypeID === 1 && !window.LYSAGHT && designType === GABLE_PORTAL && BeamAndPostParams.PortalPostType === 0) {
        beamMenuItems.push({
            Key: BeamAndPostParams.BeamType1,
            Display: "Match Column",
            Thumbnail: allBeamDisplayDetails?.[BeamAndPostParams.BeamType1]?.thumbnail,
        });
        return beamMenuItems;
    }

    let beamConfig;

    if (beamTypeID === 2 && !isFlat && hasRidgeBeam) {
        beamConfig = designOptions?.beam_2_inset;
    } else {
        beamConfig = designOptions?.[beamTypeNum];
    }

    beamConfig = beamConfig || {};
    beamConfig.options = beamConfig.options || {};

    // Set menu items to current selection if config is empty e.g. for carports and other templated designs
    if (Object.keys(beamConfig.options).length === 0) {
        const beamName = BeamAndPostParams?.[beamType];

        if (beamName) {
            beamConfig.options.currentSelection = [beamName];
        }
    }

    let disableRHS = false;

    if (!window.LYSAGHT) {
        if (length > maxLengthRHS) disableRHS = true;
    }

    if (beamConfig) {
        for (let header in beamConfig.options) {
            if (header !== "currentSelection") {
                beamMenuItems.push(<ListSubheader key={header}>{header}</ListSubheader>);
            }

            for (let beamSize of beamConfig.options[header]) {
                if (check_cyclonic(beamConfig?.disabled_on_cyclonic, beamSize, is_cyclonic)) continue;

                const beamDisplayDetails = allBeamDisplayDetails?.[beamSize];

                let displayID = beamDisplayDetails?.id ? beamDisplayDetails.id : beamSize;
                let displayName = beamDisplayDetails?.name ? beamDisplayDetails.name : beamSize;
                let thumbnail = beamDisplayDetails?.thumbnail;
                let isRHS = beamConfig?.options["Box with RHS Insert"]?.includes(displayName);
                let disableClick = false;
                let tooltip = null;

                // Function to normalize rafterBeam by stripping everything after 'M' if present
                function normalizeBeam(beam) {
                    return beam?.split("M")[0]; // Split on 'M' and take the part before it
                }

                if (window.LYSAGHT) {
                    // Hip/Dutch Beam
                    if (beamTypeID === 4) {
                        const normalizedRafterBeam = normalizeBeam(BeamAndPostParams?.[rafterBeam]);
                        const invalidHipDutchCombinations = {
                            FL20020: {
                                FL10011:
                                    "FL100 hip beam cannot be used with an FL200 Rafter because Purlin needs to be at least FL150.",
                            },
                        };
                        // Purlin Must be < or = to Hip in this case
                        if (invalidHipDutchCombinations[normalizedRafterBeam]?.[beamSize]) {
                            disableClick = true;
                            tooltip = invalidHipDutchCombinations[normalizedRafterBeam][beamSize];
                        }

                        if (areaSpecs.META.HasHips && BeamAndPostParams?.CollarTie) {
                            if (BeamAndPostParams?.BeamType1.includes(beamSize)) {
                                displayName += " (Match Rafter)";
                            } else {
                                disableClick = true;
                                tooltip = "Hip Rafters must match Rafter when there is a collar tie";
                            }
                        }
                    }
                    if (beamTypeID === 2) {
                        if (designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && BeamAndPostParams?.CollarTie) {
                            if (BeamAndPostParams?.BeamType1.includes(beamSize)) {
                                displayName += " (Match Rafter)";
                            } else {
                                disableClick = true;
                                tooltip = "Purlins must match Rafters when collar tied.";
                            }
                        } else {
                            const invalidCombinations = {
                                FL10011: {
                                    FL15015: "FL150 purlin cannot be used with an FL100 Rafter",
                                    FL20020: "FL200 purlin cannot be used with an FL100 Rafter",
                                },
                                FL15015: {
                                    FL20020: "FL200 purlin cannot be used with an FL150 Rafter",
                                },
                                FL20020: {
                                    FL10011: "FL100 purlin cannot be used with an FL200 Rafter",
                                },
                            };

                            if (hasHiporDutch && !isFlat) {
                                const normalizedHipBeam = normalizeBeam(BeamAndPostParams?.["BeamType4"]);

                                const invalidHipDutchCombinations = {
                                    FL15015: {
                                        FL20020: "FL200 purlin cannot be used with an FL150 Hip Beam",
                                    },
                                    FL10011: {
                                        FL15015: "FL150 purlin cannot be used with an FL100 Hip Beam",
                                        FL20020: "FL200 purlin cannot be used with an FL100 Hip Beam",
                                    },
                                };
                                // Purlin Must be < or = to Hip in this case
                                if (invalidHipDutchCombinations[normalizedHipBeam]?.[beamSize]) {
                                    disableClick = true;
                                    tooltip = invalidHipDutchCombinations[normalizedHipBeam][beamSize];
                                }
                            }

                            const normalizedRafterBeam = normalizeBeam(BeamAndPostParams?.[rafterBeam]);

                            if (invalidCombinations[normalizedRafterBeam]?.[beamSize]) {
                                disableClick = true;
                                tooltip = invalidCombinations[normalizedRafterBeam][beamSize];
                            }
                        }
                    }

                    if (designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && BeamAndPostParams?.CollarTie) {
                        displayID = normalizeBeam(displayID);
                    }
                }

                if (isRHS && disableRHS && disableClick === false) {
                    disableClick = true;
                    tooltip = "Beam length exceeds RHS insert availability";
                }

                if (window.FIELDERS) {
                    if (beamTypeID === 2 && is_part_of_hip_junction && normalizeBeam(displayID) !== "656510") {
                        disableClick = true;
                        tooltip = "Purlin must be a 656510 in a Hip Jjunction";
                    }
                }

                if (beamDisplayDetails) {
                    beamMenuItems.push({
                        Key: displayID,
                        Display: displayName,
                        Thumbnail: thumbnail,
                        disabled: disableClick,
                        disabledTooltip: tooltip,
                    });
                }
            }
        }
    }

    return beamMenuItems;
}

export default function SpecBeamPostTools(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { areaIndex, currentHashCode } = props;
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];
    const footingMods = area_design_specs?.["Footings"];
    const maxLengthRHS = 8000;
    const BeamPostParameters = area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS];
    const carportMode = job?.DesignParameters?.CarportMode === 1;
    const designType = carportMode ? "National Carport" : area_design_specs.SHAPE.DesignType;
    const area_config = config?.design_options?.[designType];
    const app = useSelector((state) => state.app);
    const isFirstRender = React.useRef(true);
    const engineeringHash = get(job, "QuoteParameters.ENGINEERING.engineeringHashCode");
    const [engHash, setEngHash] = React.useState(engineeringHash);
    const persistEngHash = React.useRef(engineeringHash);
    const footingSvgLoaded = extractRefsFromSVG("post_footing").length > 0;

    let last_area_data = job?.AreaSpecifications?.[areaIndex - 1];
    let this_area_data = job?.AreaSpecifications?.[areaIndex];
    let next_area_data = job?.AreaSpecifications?.[areaIndex + 1];

    if (persistEngHash.current !== engineeringHash) {
        persistEngHash.current = engineeringHash;
        setEngHash(engineeringHash);
    }

    const updateBeamPostData =
        (dataField, in_value = null) =>
        (event, value = null) => {
            if (in_value !== null) value = in_value;
            else if (value === null) value = event?.target?.value ? event?.target?.value : event;
            if (value?.props?.value !== undefined) value = value.props.value;

            updateBeamPostDataVal(dataField, value);
        };

    const updateBeamPostDataVal = (dataField, value = null) => {
        let error = dispatch(updateAreaSpecificationBeamPost(areaIndex, null, dataField, value));
        if (error && error.error) {
            dispatch(APP.showDialog(error?.title ? error?.title : "", error.message ? error?.message : ""));
        }

        if (dataField.includes("Collar")) {
        } else if (dataField === "BeamColMatchBeam" || dataField.includes("Col")) {
            Paper.UpdateBeamsAndPosts(false, 1);
        }
        return;
    };

    const updateCarportFooting = (numBoltedToSlab) => {
        const refValues = extractRefsFromSVG("post_footing");

        if (numBoltedToSlab === 0) {
            dispatch(updateAreaSpecification(areaIndex, "Footings", null, []));
        } else {
            let newDataArray = [];

            for (let i = 0; i < numBoltedToSlab; i++) {
                newDataArray.push({
                    Ref: refValues[i],
                    Ref2: refValues[i],
                    Position: refValues[i].replaceAll("/", ","),
                    Kind: "Bolt to Slab",
                    Connector: 2,
                });
            }

            dispatch(updateAreaSpecification(areaIndex, "Footings", null, newDataArray));
        }
    };

    const handleCarportFootingUpdate = (e, numBoltedToSlab) => {
        updateCarportFooting(numBoltedToSlab);
    };

    const updateCollarTie = (value = null) => {
        if (window?.job?.QuoteParameters?.ENGINEERING) window.job.QuoteParameters.ENGINEERING.EngineeringResults = null;
        if (value !== 0) {
            dispatch(updateAreaSpecificationBeamPost(areaIndex, null, "CollarTieBeam", value));
        }
        let error = dispatch(updateAreaSpecificationBeamPost(areaIndex, null, "CollarTie", value ? 1 : 0));
        if (error && error.error) {
            dispatch(APP.showDialog(error?.title ? error?.title : "", error.message ? error?.message : ""));
        } else {
            dispatch(updateAreaSpecificationBeamPost(areaIndex, null, "CollarTieBeam", value));
        }
    };

    let postParameters = area_design_specs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS];
    const postgroup = config?.post_types?.[postParameters.PostType];

    // This is only relevant to carports created via the API
    React.useEffect(() => {
        if (footingSvgLoaded && carportMode && Array.isArray(footingMods)) {
            const hasTBD = footingMods.some((mod) => Object.values(mod).some((value) => value === "TBD"));

            if (hasTBD) {
                updateCarportFooting(footingMods.length);
            }
        }
    }, [footingMods, footingSvgLoaded]);

    // Removes invalid beams and replaces them with the default selection
    // Only runs if the engineering hash has changed (e.g. if building dimensions are modified)
    React.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (!window.LYSAGHT) {
            let invalidBeams = validateRHSBeamLength(config, job, areaIndex);

            if (invalidBeams.size) {
                let beamsToNotify = [];

                for (let beam of invalidBeams) {
                    const regexMatch = beam.match(/\d+/);
                    const digit = regexMatch ? regexMatch[0] : null;
                    const beamID = "beam_" + digit;

                    beamsToNotify.push(config?.design_options?.[designType]?.[beamID]?.Name);
                    job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS][beam] =
                        config?.design_options?.[designType]?.[beamID]?.section_default;

                    // Restore default beam selection
                    dispatch({
                        type: "NEW_JOB",
                        index: areaIndex,
                        section: null,
                        subsection: null,
                        parameter: job,
                        value: null,
                        error: null,
                    });

                    let beamModRefs = [];

                    // Clear beam mods which are no longer valid
                    switch (beamID) {
                        case "beam_1":
                            if (designType === CONFIG.DESIGN_TYPES.FLAT) {
                                beamModRefs.push("Front", "Back");
                            } else if (designType === CONFIG.DESIGN_TYPES.PITCHED) {
                                beamModRefs.push("Portal");
                            } else if (designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                                beamModRefs.push("Portal");
                            }
                            break;

                        case "beam_2":
                            if (designType === CONFIG.DESIGN_TYPES.FLAT) {
                                beamModRefs.push("Purlin");
                            } else if (designType === CONFIG.DESIGN_TYPES.PITCHED) {
                                beamModRefs.push("Ridge");
                            } else if (designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                                beamModRefs.push("Purlin", "Dutch");
                            }
                            break;

                        case "beam_3":
                            if (designType === CONFIG.DESIGN_TYPES.FLAT) {
                                beamModRefs.push("Beam");
                            } else if (designType === CONFIG.DESIGN_TYPES.PITCHED) {
                                beamModRefs.push("Front", "Back");
                            } else if (designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                                beamModRefs.push("Front", "Back");
                            }
                            break;

                        case "beam_4":
                            if (designType === CONFIG.DESIGN_TYPES.PITCHED) {
                                beamModRefs.push("Pitching");
                            } else if (designType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                                beamModRefs.push("Hip");
                            }
                            break;
                    }

                    if (beamModRefs.length > 0) {
                        const beamMods = area_design_specs?.BEAMMODIFICATIONS;

                        const filteredData = beamMods.filter((item) =>
                            beamModRefs.some((target) => item.Ref2.includes(target))
                        );

                        for (let i = 0; i < filteredData.length; i++) {
                            dispatch(
                                deleteFromAreaSpecificationModificationArray(
                                    areaIndex,
                                    "BEAMMODIFICATIONS",
                                    filteredData[i].Ref
                                )
                            );
                        }
                    }
                }

                const formattedBeamsToNotify = beamsToNotify.map((beam) => `\t� ${beam}`).join("\n");
                dispatch(
                    APP.showDialog(
                        "Beam length exceeds RHS insert availability",
                        `The following beams have been changed to box beams without RHS as they exceed the ${maxLengthRHS}mm limit for RHS inserts:\n${formattedBeamsToNotify}`,
                        "Acknowledge"
                    )
                );
            }
        }
    }, [engHash]);

    // Ensures posts with RHS inserts have 'in ground' footings
    React.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (!window.LYSAGHT) {
            let invalidFootings = validateRHSPostFooting(config, job, areaIndex);

            if (invalidFootings.length > 0) {
                const isDefault = invalidFootings.some((item) => item.isDefault === true);
                let dispatchParams;

                if (isDefault) {
                    // Default/global footing selection needs to be changed
                    dispatchParams = [areaIndex, BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "FootingType", "Concrete In"];
                } else {
                    // Only footing mods need to be cleared
                    dispatchParams = [areaIndex, "Footings", null, []];
                }

                dispatch(updateAreaSpecification(...dispatchParams)).then(() => {
                    dispatch(
                        APP.showDialog(
                            "Footings have changed",
                            "Footings have been changed to concrete in slab to accomodate RHS inserts in columns.\nPlease review your design's footings to see where changes have been made.",
                            "Acknowledge"
                        )
                    );
                });
            }
        }
    }, [engHash]);

    let is_part_of_hip_junction = false;
    if (
        (next_area_data && this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Hip") ||
        (last_area_data && last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Hip") ||
        (next_area_data && this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Gable") ||
        (last_area_data && last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Gable")
    ) {
        is_part_of_hip_junction = true;
    }

    let engValid = false;
    if (engineeringHash && currentHashCode && engineeringHash === currentHashCode) engValid = true;

    const shapeParameters = area_design_specs?.[BASIC_SPECS_SECTIONS.SHAPE];

    const OVERSTRESS_FACTOR = 1.03;

    const PostMaxResults =
        Number(get(job, "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".ColumnsMax")) /
        OVERSTRESS_FACTOR;

    const ColumnsMaxText = get(
        job,
        "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".ColumnsMaxText"
    );

    const FasciaMaxResults = Number(
        get(job, "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".FasciaMax")
    );
    const PurlinMaxResults = Number(
        get(job, "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".PurlinMax")
    );
    const RafterMaxResults = Number(
        get(job, "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".RafterMax")
    );
    const EdgeBeamMaxResults = Number(
        get(job, "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".EdgeBeamMax")
    );
    const HipRafterMaxResults = Number(
        get(job, "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".HipRafterMax")
    );
    const JoinBeamMaxResults = Number(
        get(job, "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".JoinBeamMax")
    );
    const MaxResult = Number(
        get(job, "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".MaxResult")
    );
    const MaxResultText = get(
        job,
        "QuoteParameters.ENGINEERING.EngineeringResults.AreaMaxResults." + areaIndex + ".MaxResultText"
    );

    let beam1_eng_result = FasciaMaxResults / OVERSTRESS_FACTOR;
    let beam2_eng_result = PurlinMaxResults / OVERSTRESS_FACTOR;
    let beam3_eng_result = RafterMaxResults / OVERSTRESS_FACTOR;
    let beam4_eng_result = null;
    let join_eng_result = JoinBeamMaxResults / OVERSTRESS_FACTOR;

    if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) {
        beam1_eng_result = RafterMaxResults / OVERSTRESS_FACTOR;
        beam2_eng_result = PurlinMaxResults / OVERSTRESS_FACTOR;
        beam3_eng_result = FasciaMaxResults / OVERSTRESS_FACTOR;
        beam4_eng_result = EdgeBeamMaxResults / OVERSTRESS_FACTOR;
    } else if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
        beam1_eng_result = RafterMaxResults / OVERSTRESS_FACTOR;
        beam2_eng_result = PurlinMaxResults / OVERSTRESS_FACTOR;
        beam3_eng_result = EdgeBeamMaxResults / OVERSTRESS_FACTOR;
        beam4_eng_result = HipRafterMaxResults / OVERSTRESS_FACTOR;
    }

    let has_join_beam = false;
    if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) {
        if (areaIndex < job.AreaSpecifications.length - 1 && area_design_specs.SHAPE.AREAJOIN.JoinType !== "None") {
            has_join_beam = true;
            join_eng_result = JoinBeamMaxResults / OVERSTRESS_FACTOR;
        }
    }

    const beam_types = config.beam_types;
    const post_types = config.post_types;

    let colourMatch = {
        "Match Post": BeamPostParameters.PostCol,
        "Match Area 1 Post": job?.AreaSpecifications?.[0]?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.PostCol,
    };

    const post = area_config?.post;
    let area_freestanding = area_design_specs[BASIC_SPECS_SECTIONS.ATTACHMENTS].Freestanding;

    let is_cyclonic = false;
    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    if (region === "C" || region === "D") {
        is_cyclonic = true;
    }

    let post_menu_items = [];

    let options = post?.options;
    options = options || {};

    if (area_freestanding && post?.freestanding_options) options = post?.freestanding_options;

    if (BeamPostParameters.PortalPostType === 1 && post?.non_portal_options) {
        if (typeof post.non_portal_options === "object" && post.non_portal_options !== null) {
            options = post.non_portal_options;
        }
    }

    if (typeof options === "object" && options !== null) {
        if (Object.keys(options).length === 0) {
            options.currentSelection = [BeamPostParameters.PostType];
        }
    }

    let corner_post_must_be_90_for_hip = Check_corner_post_must_be_90_for_hip(area_design_specs);

    if (post && options) {
        for (let key in options) {
            if (job?.SiteParameters?.Address?.State.toUpperCase() == "NSW" && key.toUpperCase() == "SHS ALUMINIUM")
                continue;

            if (options?.[key] && Object.keys(options?.[key]).length > 0) {
                if (key !== "currentSelection") {
                    post_menu_items.push(<ListSubheader key={key}>{key.replace("Beam", "Post")}</ListSubheader>);
                }
            }

            if (options?.[key])
                for (let key2 of options[key]) {
                    if (check_cyclonic(post?.disabled_on_cyclonic, key2, is_cyclonic)) continue;

                    const this_post = post_types?.[key2];
                    if (this_post) {
                        let disabled = false;
                        let disabledTooltip = "";
                        let disabled_freestanding = area_freestanding && this_post.allow_freestanding === false;

                        if (disabled_freestanding) {
                            disabledTooltip = "Not suitable for freestanding";
                        }

                        let display_name = this_post.name ? this_post.name.replace("Beam", "Post") : key2;

                        if (corner_post_must_be_90_for_hip && display_name && !display_name.includes("90mm")) {
                            disabled = true;
                            disabledTooltip = "Not suitable for Gable Hip Corner Posts";
                        }

                        post_menu_items.push({
                            Key: this_post.id ? this_post.id : key2,
                            Display: display_name + (disabled_freestanding ? " (not suitable)" : ""),
                            Thumbnail: this_post.thumbnail,
                            disabled: disabled_freestanding || disabled,
                            disabledTooltip: disabledTooltip,
                        });
                    }
                }
        }
    }

    const beam1 = area_config.beam_1;
    const beam3 = area_config.beam_3;
    const beam4 = area_config.beam_4;

    let beam2 = area_config.beam_2;

    if (
        area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
        area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
    ) {
        if (area_design_specs.BEAMS_AND_POSTS.HasRidgeBeam === 1 && area_config?.beam_2_inset)
            beam2 = area_config.beam_2_inset;
    }

    let has_beam4 = true;

    if (
        area_design_specs.SHAPE.DesignType === "Gable Hip Roof" &&
        shapeParameters.RoofType1 === "Gable" &&
        shapeParameters.RoofType2 === "Gable"
    ) {
        has_beam4 = false;
    }

    let beams = [beam1, beam2, beam3, beam4];
    let rafterBeam = beams.find((beam) => beam.Name === "Rafter");

    rafterBeam = rafterBeam ? `BeamType${beams.indexOf(rafterBeam) + 1}` : "BeamType1";

    let beam1_menu_items = get_beam_menu_items(config, job, 1, areaIndex, is_cyclonic, rafterBeam);
    let beam2_menu_items = get_beam_menu_items(config, job, 2, areaIndex, is_cyclonic, rafterBeam);
    let beam3_menu_items = get_beam_menu_items(config, job, 3, areaIndex, is_cyclonic, rafterBeam);
    let beam4_menu_items = get_beam_menu_items(config, job, 4, areaIndex, is_cyclonic, rafterBeam);

    const wipeBeamMods = () => {
        dispatch(updateAreaSpecification(0, BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS, null, []));
        dispatch(updateAreaSpecification(0, BASIC_SPECS_SECTIONS.BEAMSPECMODIFICATIONS, null, []));
        dispatch(updateAreaSpecification(areaIndex, "NewPosts", null, []));
        dispatch(updateAreaSpecification(0, BASIC_SPECS_SECTIONS.BEAMADJUSTMENTS, null, []));
        dispatch(updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.BEAMWALLEXTENDS, null, []));
    };

    const wipePostMods = () => {
        dispatch(updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.POSTMODIFICATIONS, null, []));
        dispatch(updateAreaSpecification(areaIndex, "DeletePosts", null, {}));
        dispatch(updateAreaSpecification(areaIndex, "NewPosts", null, []));
        dispatch(updateAreaSpecification(areaIndex, "PostPositionAdjustments", null, []));
        dispatch(
            updateAreaSpecification(areaIndex, BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, null, {
                ...BeamPostParameters,
                NumExtraPostsFront1: 0,
                NumExtraPostsBack1: 0,
                NumExtraPostsCFLX: 0,
                NumExtraPostsCFRX: 0,
                NumExtraPostsCBLX: 0,
                NumExtraPostsCBRX: 0,
            })
        );

        let new_beam_mods = [...area_design_specs.BEAMMODIFICATIONS];
        for (let mod of new_beam_mods) {
            mod.Overhang1 = 0;
            mod.Overhang2 = 0;
            mod.NumInternalPosts = 0;
            mod.EvenlySpacePosts = 1;
            mod.InternalPostOffsets = [];
        }
        dispatch(updateAreaSpecification(0, BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS, null, new_beam_mods));
    };

    let deckMode = false;
    if (designType === CONFIG.DESIGN_TYPES.DECK) deckMode = true;

    let Cached_Icon = (
        <CachedIcon
            style={{ verticalAlign: "top", animation: app?.loadingEngineering ? "spin 4s linear infinite" : "" }}
        />
    );

    let post_top_connection_allowed = PostTypeTopConnectionAllowed(
        post_types,
        BeamPostParameters.PostType,
        BeamPostParameters.PostCol,
        is_cyclonic
    );

    let post_colours = GetColourArray(postgroup?.colours ? postgroup?.colours : post.colours, config.colour_arrays);

    let min_internal_rafters =
        BeamPostParameters?.MinInternalRafters && BeamPostParameters?.MinInternalRafters < 20
            ? BeamPostParameters?.MinInternalRafters
            : 0;

    let int_rafters_list = CreateIntegerRange(min_internal_rafters, min_internal_rafters + 9, 1);

    let post_name = post?.Name;
    let beam1_name = beam1.Name;
    if (BeamPostParameters?.PortalPostType === 1) {
        post_name = post_name.replace("Portal", "Gable");
        beam1_name = beam1_name.replace("Portal", "Gable");
    }

    return (
        <div className={classes.root}>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader style={{ paddingTop: "0px" }}>
                    <Tooltip title={window.debug ? ColumnsMaxText : ""}>
                        <div
                            className={
                                engValid && PostMaxResults && PostMaxResults > 0
                                    ? PostMaxResults <= 1
                                        ? PostMaxResults <= 0.9
                                            ? classes.header_pass
                                            : classes.header_warning
                                        : classes.header_fail
                                    : classes.header_unknown
                            }
                        >
                            <span style={{ paddingTop: "3px" }}>{post_name}s</span>
                            <span style={{ marginLeft: "5px" }}>
                                {engValid && PostMaxResults ? (
                                    PostMaxResults <= 1 ? (
                                        <CheckCircleIcon style={{ verticalAlign: "top" }} />
                                    ) : (
                                        <CrossCircleIcon style={{ verticalAlign: "top" }} />
                                    )
                                ) : (
                                    Cached_Icon
                                )}{" "}
                            </span>
                            <span className={classes.result_item}>
                                {engValid && PostMaxResults ? (PostMaxResults * 100).toFixed(1) + "%" : "??.?%"}
                            </span>
                        </div>
                    </Tooltip>
                </BSL_Common.SectionHeader>
                <BSL_Select
                    style={{ flex: 1 }}
                    selectStyle={{
                        background:
                            engValid && PostMaxResults && PostMaxResults > 0
                                ? PostMaxResults <= 1
                                    ? "#99c995"
                                    : "#ff9a9a"
                                : "#fff",
                    }}
                    value={BeamPostParameters.PostType}
                    tight={true}
                    items={post_menu_items}
                    onChange={updateBeamPostData("PostType")}
                    disabled={post_menu_items.length <= 1}
                />
                <BSL_ColourSelector
                    tight
                    label="Colour"
                    colourList={
                        areaIndex > 0
                            ? ["Match Area 1 Post", post_colours]
                            : post_colours.length === 1
                            ? [post_colours]
                            : ["TBA", post_colours]
                    }
                    value={BeamPostParameters.PostColMatchBeam}
                    onChange={updateBeamPostData("PostColMatchBeam")}
                    colourMatch={colourMatch}
                    style={{
                        marginTop: "-12px",
                    }}
                />

                {carportMode &&
                    !is_cyclonic &&
                    job?.AreaSpecifications[0]?.SHAPE?.DesignTemplateName.includes("Non-Cyclonic") && (
                        <SegmentedButtonGroup
                            label="Number of flange posts (bolt to slab)"
                            value={area_design_specs?.["Footings"]?.length || 0}
                            tight
                            items={[0, 1, 2, 3, 4]}
                            onChange={(e, val) => {
                                handleCarportFootingUpdate(e, val);
                            }}
                        />
                    )}

                {!deckMode && !carportMode && window.LYSAGHT && (
                    <>
                        <SegmentedButtonGroup
                            label="Corner Post Top Connection Style"
                            tight
                            value={BeamPostParameters.CornerPostsFullHeight}
                            items={[
                                {
                                    Key: 1,
                                    Display: "Beam to Side",
                                    disabled: !post_top_connection_allowed.post_side_allowed,
                                    disabledTooltip: post_top_connection_allowed.post_side_disabled_helpertext,
                                },
                                {
                                    Key: 2,
                                    Display: "Notched",
                                    disabled: !post_top_connection_allowed.post_notch_allowed,
                                    disabledTooltip: post_top_connection_allowed.post_notch_disabled_helpertext,
                                },
                                {
                                    Key: 3,
                                    Display: "Post Behind Beam",
                                    disabled: !post_top_connection_allowed.post_behind_allowed,
                                    disabledTooltip: post_top_connection_allowed.post_behind_allowed_helpertext,
                                },
                            ]}
                            onChange={updateBeamPostData("CornerPostsFullHeight")}
                            style={{
                                marginTop: "-8px",
                            }}
                        />

                        {!carportMode && (
                            <SegmentedButtonGroup
                                label="Intermediate Post Top Connection Style"
                                tight
                                value={BeamPostParameters.IntermediatePostsFullHeight}
                                items={[
                                    {
                                        Key: 1,
                                        Display: "Beam to Side",
                                        disabled: !post_top_connection_allowed.post_side_allowed,
                                        disabledTooltip: post_top_connection_allowed.post_side_disabled_helpertext,
                                    },
                                    {
                                        Key: 2,
                                        Display: "Notched",
                                        disabled: !post_top_connection_allowed.post_notch_allowed,
                                        disabledTooltip: post_top_connection_allowed.post_notch_disabled_helpertext,
                                    },
                                    {
                                        Key: 3,
                                        Display: "Post Behind Beam",
                                        disabled: !post_top_connection_allowed.post_behind_allowed,
                                        disabledTooltip: post_top_connection_allowed.post_behind_allowed_helpertext,
                                    },
                                ]}
                                onChange={updateBeamPostData("IntermediatePostsFullHeight")}
                                style={{
                                    marginTop: "-12px",
                                }}
                            />
                        )}
                        <BSL_Button style={{ marginLeft: "8px", alignSelf: "center" }} onClick={wipePostMods}>
                            Reset Post Modifications (Area)
                        </BSL_Button>
                    </>
                )}
                {!deckMode &&
                    window.FIELDERS &&
                    area_design_specs.SHAPE.DesignType !== CONFIG.DESIGN_TYPES.GABLE_PORTAL && (
                        <>
                            <SegmentedButtonGroup
                                label="Corner Post Top Connection"
                                tight
                                value={BeamPostParameters.CornerPostsFullHeight}
                                items={[
                                    {
                                        Key: 1,
                                        Display: "Beam to Side",
                                        disabled: !post_top_connection_allowed.post_side_allowed,
                                        disabledTooltip: post_top_connection_allowed.post_side_disabled_helpertext,
                                    },
                                    {
                                        Key: 0,
                                        Display: "Post Under Beam",
                                        disabled: !post_top_connection_allowed.post_under_allowed,
                                        disabledTooltip: post_top_connection_allowed.post_under_allowed_helpertext,
                                    },
                                ]}
                                onChange={updateBeamPostData("CornerPostsFullHeight")}
                                style={{
                                    marginTop: "-12px",
                                }}
                            />
                            <SegmentedButtonGroup
                                label="Intermediate Post Top Con."
                                tight
                                value={BeamPostParameters.IntermediatePostsFullHeight}
                                items={[
                                    {
                                        Key: 1,
                                        Display: "Beam to Side",
                                        disabled: !post_top_connection_allowed.post_side_allowed,
                                        disabledTooltip: post_top_connection_allowed.post_side_disabled_helpertext,
                                    },
                                    {
                                        Key: 0,
                                        Display: "Post Under Beam",
                                        disabled: !post_top_connection_allowed.post_under_allowed,
                                        disabledTooltip: post_top_connection_allowed.post_under_allowed_helpertext,
                                    },
                                ]}
                                onChange={updateBeamPostData("IntermediatePostsFullHeight")}
                                style={{
                                    marginTop: "-12px",
                                }}
                            />
                            <BSL_Button style={{ marginLeft: "8px", alignSelf: "center" }} onClick={wipePostMods}>
                                Reset Post Modifications (Area)
                            </BSL_Button>
                        </>
                    )}
                {!deckMode &&
                    window.FIELDERS &&
                    area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && (
                        <>
                            <SegmentedButtonGroup
                                label="Post Type"
                                tight
                                value={BeamPostParameters.PortalPostType}
                                items={[
                                    {
                                        Key: 0,
                                        Display: "Portal Frame",
                                    },
                                    {
                                        Key: 1,
                                        Display: "SHS Posts",
                                    },
                                ]}
                                onChange={updateBeamPostData("PortalPostType")}
                                style={{
                                    marginTop: "-12px",
                                }}
                            />
                            {BeamPostParameters.PortalPostType == 1 && (
                                <>
                                    <SegmentedButtonGroup
                                        label="Corner Post Top Connection"
                                        tight
                                        value={BeamPostParameters.CornerPostsFullHeight}
                                        items={[
                                            {
                                                Key: 1,
                                                Display: "Beam to Side",
                                                disabled: !post_top_connection_allowed.post_side_allowed,
                                                disabledTooltip:
                                                    post_top_connection_allowed.post_side_disabled_helpertext,
                                            },
                                            {
                                                Key: 0,
                                                Display: "Post Under Beam",
                                                disabled: !post_top_connection_allowed.post_under_allowed,
                                                disabledTooltip:
                                                    post_top_connection_allowed.post_under_allowed_helpertext,
                                            },
                                        ]}
                                        onChange={updateBeamPostData("CornerPostsFullHeight")}
                                        style={{
                                            marginTop: "-12px",
                                        }}
                                    />
                                    <SegmentedButtonGroup
                                        label="Intermediate Post Top Con."
                                        tight
                                        value={BeamPostParameters.IntermediatePostsFullHeight}
                                        items={[
                                            {
                                                Key: 1,
                                                Display: "Beam to Side",
                                                disabled: !post_top_connection_allowed.post_side_allowed,
                                                disabledTooltip:
                                                    post_top_connection_allowed.post_side_disabled_helpertext,
                                            },
                                            {
                                                Key: 0,
                                                Display: "Post Under Beam",
                                                disabled: !post_top_connection_allowed.post_under_allowed,
                                                disabledTooltip:
                                                    post_top_connection_allowed.post_under_allowed_helpertext,
                                            },
                                        ]}
                                        onChange={updateBeamPostData("IntermediatePostsFullHeight")}
                                        style={{
                                            marginTop: "-12px",
                                        }}
                                    />
                                </>
                            )}
                            <BSL_Button style={{ marginLeft: "8px", alignSelf: "center" }} onClick={wipePostMods}>
                                Reset Post Modifications (Area)
                            </BSL_Button>
                        </>
                    )}
                {deckMode && (
                    <BSL_TextInput
                        label="Post Spacing"
                        value={BeamPostParameters?.PostSpacing}
                        tight
                        min={200}
                        max={4080}
                        endAdornment="mm"
                        onBlur={updateBeamPostData("PostSpacing")}
                        style={{
                            width: "120px",
                        }}
                    />
                )}
            </BSL_Common.SectionContainer>

            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>
                    <div
                        className={
                            engValid && beam1_eng_result && beam1_eng_result > 0
                                ? beam1_eng_result <= 1
                                    ? beam1_eng_result <= 0.9
                                        ? classes.header_pass
                                        : classes.header_warning
                                    : classes.header_fail
                                : classes.header_unknown
                        }
                    >
                        <span style={{ paddingTop: "3px" }}>{beam1_name}s</span>
                        <span style={{ marginLeft: "5px" }}>
                            {engValid && beam1_eng_result ? (
                                beam1_eng_result <= 1 ? (
                                    <CheckCircleIcon style={{ verticalAlign: "top" }} />
                                ) : (
                                    <CrossCircleIcon style={{ verticalAlign: "top" }} />
                                )
                            ) : (
                                Cached_Icon
                            )}{" "}
                        </span>
                        <span className={classes.result_item}>
                            {engValid && beam1_eng_result ? (beam1_eng_result * 100).toFixed(1) + "%" : "??.?%"}
                        </span>
                    </div>
                </BSL_Common.SectionHeader>
                <BSL_Select
                    style={{ flex: 1 }}
                    selectStyle={{
                        background:
                            engValid && beam1_eng_result && beam1_eng_result > 0
                                ? beam1_eng_result <= 1
                                    ? "#99c995"
                                    : "#ff9a9a"
                                : "#fff",
                    }}
                    value={BeamPostParameters.BeamType1}
                    tight={true}
                    items={beam1_menu_items}
                    onChange={updateBeamPostData("BeamType1")}
                    disabled={beam1_menu_items.length <= 1}
                />
                <BSL_ColourSelector
                    tight
                    label="Colour"
                    colourList={["Match Post", "TBA", beam1.colours]}
                    value={BeamPostParameters.BeamColMatchBeam}
                    onChange={updateBeamPostData("BeamColMatchBeam")}
                    colourMatch={colourMatch}
                    style={{
                        marginTop: "-12px",
                    }}
                />
                {area_design_specs.SHAPE.DesignType === "Gable Hip Roof" && (
                    <>
                        {window.LYSAGHT && (
                            <SegmentedButtonGroup
                                value={BeamPostParameters?.CollarTie ? BeamPostParameters.CollarTieBeam : 0}
                                tight
                                items={
                                    window.LYSAGHT
                                        ? [
                                              {
                                                  Key: 0,
                                                  Display: "No Collar Tie",
                                                  disabled: BeamPostParameters.BeamType1.includes("FL10011"),
                                                  disabledTooltip: BeamPostParameters.BeamType1.includes("FL10011")
                                                      ? "FL100 must have collar ties"
                                                      : "",
                                              },
                                              {
                                                  Key: "FL10011",
                                                  Display: "Collar Tie (FL100)",
                                                  disabled: BeamPostParameters.BeamType1.includes("FL20020"),
                                                  disabledTooltip: BeamPostParameters.BeamType1.includes("FL20020")
                                                      ? "FL200 cannot have collar ties"
                                                      : "",
                                              },
                                              {
                                                  Key: "FL15015",
                                                  Display: "Collar Tie (FL150)",
                                                  disabled: BeamPostParameters.BeamType1.includes("FL20020"),
                                                  disabledTooltip: BeamPostParameters.BeamType1.includes("FL20020")
                                                      ? "FL200 cannot have collar ties"
                                                      : "",
                                              },
                                          ]
                                        : [
                                              { Key: 0, Display: "No Collar Tie" },
                                              { Key: "1086510", Display: "108 Box Collar Tie" },
                                              { Key: "1586510", Display: "158 Box Collar Tie" },
                                          ]
                                }
                                onChange={(e, val) => {
                                    updateCollarTie(val);
                                }}
                            />
                        )}
                        {window.LYSAGHT && (
                            <SegmentedButtonGroup
                                label=""
                                tight
                                value={BeamPostParameters.DoubleIntermediateRafters}
                                items={[
                                    {
                                        Key: 0,
                                        Display: "Single Rafters",
                                    },
                                    {
                                        Key: 1,
                                        Display: "Double Intermediate Rafters",
                                        disabled:
                                            BeamPostParameters?.BeamType1.includes("FL10011") ||
                                            BeamPostParameters?.CollarTie === 1,
                                        disabledTooltip: BeamPostParameters?.BeamType1.includes("FL10011")
                                            ? "FL10011 Cannot be double rafter as must have collar ties"
                                            : BeamPostParameters?.CollarTie === 1
                                            ? "Only available when no collar tie"
                                            : "",
                                    },
                                ]}
                                onChange={updateBeamPostData("DoubleIntermediateRafters")}
                                style={{
                                    marginTop: "-12px",
                                }}
                            />
                        )}
                        {area_design_specs.SHAPE.DesignType === "Gable Hip Roof" &&
                            (area_design_specs.SHAPE.RoofType1 !== "Gable" ||
                                area_design_specs.SHAPE.RoofType2 !== "Gable") && (
                                <SegmentedButtonGroup
                                    label=""
                                    tight
                                    value={BeamPostParameters.JackRafters ? 1 : 0}
                                    items={[
                                        {
                                            Key: 0,
                                            Display: "No Jack Rafters",
                                        },
                                        {
                                            Key: 1,
                                            Display: "Jack Rafters",
                                        },
                                    ]}
                                    onChange={updateBeamPostData("JackRafters")}
                                    style={{
                                        marginTop: "-12px",
                                    }}
                                />
                            )}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <SegmentedButtonGroup
                                style={{ flex: "none" }}
                                tight
                                items={[
                                    {
                                        Key: "Reduce",
                                        Display: <RemoveCircleIcon />,
                                        disabled:
                                            BeamPostParameters.NumPortals <= BeamPostParameters.MinInternalRafters,
                                    },
                                    {
                                        Key: "Add",
                                        Display: <AddCircleIcon />,
                                        disabled: BeamPostParameters.NumPortals >= 12,
                                    },
                                ]}
                                onChange={(e, val) => {
                                    if (val === "Add") {
                                        let num_portals = BeamPostParameters.NumPortals + 1;
                                        updateBeamPostDataVal("NumPortals", num_portals);
                                    }
                                    if (val === "Reduce") {
                                        let num_portals = BeamPostParameters.NumPortals - 1;
                                        updateBeamPostDataVal("NumPortals", num_portals);
                                    }
                                }}
                            />
                            <div className={classes.label}>
                                {" "}
                                Number of {BeamPostParameters?.PortalPostType === 0 ? "Portal Frames" : "Rafter Sets"}
                            </div>
                        </div>
                    </>
                )}
            </BSL_Common.SectionContainer>

            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>
                    <div
                        className={
                            engValid && beam2_eng_result && beam2_eng_result > 0
                                ? beam2_eng_result <= 1
                                    ? beam2_eng_result <= 0.9
                                        ? classes.header_pass
                                        : classes.header_warning
                                    : classes.header_fail
                                : classes.header_unknown
                        }
                    >
                        <span style={{ paddingTop: "3px" }}>{beam2.Name}s</span>
                        <span style={{ marginLeft: "5px" }}>
                            {engValid && beam2_eng_result ? (
                                beam2_eng_result <= 1 ? (
                                    <CheckCircleIcon style={{ verticalAlign: "top" }} />
                                ) : (
                                    <CrossCircleIcon style={{ verticalAlign: "top" }} />
                                )
                            ) : (
                                Cached_Icon
                            )}{" "}
                        </span>
                        <span className={classes.result_item}>
                            {engValid && beam2_eng_result ? (beam2_eng_result * 100).toFixed(1) + "%" : "??.?%"}
                        </span>
                    </div>
                </BSL_Common.SectionHeader>
                <BSL_Select
                    style={{ flex: 1 }}
                    selectStyle={{
                        background:
                            engValid && beam2_eng_result && beam2_eng_result > 0
                                ? beam2_eng_result <= 1
                                    ? "#99c995"
                                    : "#ff9a9a"
                                : "#fff",
                    }}
                    value={BeamPostParameters.BeamType2}
                    tight={true}
                    items={beam2_menu_items}
                    onChange={updateBeamPostData("BeamType2")}
                    disabled={beam2_menu_items.length <= 1}
                />
                <BSL_ColourSelector
                    tight
                    label="Colour"
                    colourList={["Match Post", "TBA", beam2.colours]}
                    value={BeamPostParameters.BeamCol2MatchBeam}
                    onChange={updateBeamPostData("BeamCol2MatchBeam")}
                    colourMatch={colourMatch}
                    style={{
                        marginTop: "-12px",
                    }}
                />

                {deckMode && (
                    <BSL_CheckBox
                        tight
                        checked={BeamPostParameters.MatchSideBeams}
                        returnInt
                        label="Match Edge Joist To Bearer"
                        onChange={updateBeamPostData("MatchSideBeams")}
                        style={{
                            marginTop: "-12px",
                        }}
                    />
                )}
                {!deckMode && !carportMode && (
                    <>
                        <SegmentedButtonGroup
                            label="Num Extra Purlin Rows"
                            value={BeamPostParameters.NumExtraPurlins}
                            tight
                            items={CreateIntegerRange(0, 9, 1)}
                            onChange={updateBeamPostData("NumExtraPurlins")}
                            helperText={
                                this_area_data?.META?.HasInsulatedPanel &&
                                this_area_data?.SKYLIGHTS &&
                                this_area_data?.SKYLIGHTS.length > 0 ? (
                                    <span style={{ color: "red" }}>
                                        Purlins are not added in Insulated Panel design with skylights.
                                    </span>
                                ) : (
                                    ""
                                )
                            }
                        />

                        {!window.LYSAGHT &&
                            (area_design_specs.SHAPE.DesignType === "Pitched Roof" ||
                                area_design_specs.SHAPE.DesignType === "Gable Hip Roof") && (
                                <SegmentedButtonGroup
                                    value={BeamPostParameters.HasRidgeBeam === 1 ? "Purlins Inset" : "Purlins On Top"}
                                    tight
                                    items={[
                                        {
                                            Key: "Purlins Inset",
                                            Display: "Purlins Inset",
                                        },
                                        {
                                            Key: "Purlins On Top",
                                            Display: "Purlins On Top",
                                            disabled:
                                                BeamPostParameters.PortalPostType === 1 ||
                                                (window.FIELDERS &&
                                                    job?.AreaSpecifications[areaIndex]?.META?.HasInsulatedPanel) ||
                                                is_part_of_hip_junction,
                                            disabledTooltip:
                                                BeamPostParameters.PortalPostType === 1
                                                    ? "Purlins cannot be On Top when using SHS posts"
                                                    : is_part_of_hip_junction
                                                    ? "Purlins must be inset in a Hip/Gable Junction"
                                                    : "",
                                        },
                                    ]}
                                    onChange={(e, val) => {
                                        updateBeamPostDataVal("HasRidgeBeam", val === "Purlins Inset" ? 1 : 0);
                                    }}
                                />
                            )}
                    </>
                )}
            </BSL_Common.SectionContainer>

            {beam3 && (
                <BSL_Common.SectionContainer>
                    <BSL_Common.SectionHeader>
                        <div
                            className={
                                engValid && beam3_eng_result && beam3_eng_result > 0
                                    ? beam3_eng_result <= 1
                                        ? beam3_eng_result <= 0.9
                                            ? classes.header_pass
                                            : classes.header_warning
                                        : classes.header_fail
                                    : classes.header_unknown
                            }
                        >
                            <span style={{ paddingTop: "3px" }}>{beam3.Name}s</span>
                            <span style={{ marginLeft: "5px" }}>
                                {engValid && beam3_eng_result ? (
                                    beam3_eng_result <= 1 ? (
                                        <CheckCircleIcon style={{ verticalAlign: "top" }} />
                                    ) : (
                                        <CrossCircleIcon style={{ verticalAlign: "top" }} />
                                    )
                                ) : (
                                    Cached_Icon
                                )}{" "}
                            </span>
                            <span className={classes.result_item}>
                                {engValid && beam3_eng_result ? (beam3_eng_result * 100).toFixed(1) + "%" : "??.?%"}
                            </span>
                        </div>
                    </BSL_Common.SectionHeader>
                    <BSL_Select
                        style={{ flex: 1 }}
                        selectStyle={{
                            background:
                                engValid && beam3_eng_result && beam3_eng_result > 0
                                    ? beam3_eng_result <= 1
                                        ? "#99c995"
                                        : "#ff9a9a"
                                    : "#fff",
                        }}
                        value={BeamPostParameters.BeamType3}
                        tight={true}
                        items={beam3_menu_items}
                        onChange={updateBeamPostData("BeamType3")}
                        disabled={beam3_menu_items.length <= 1}
                    />
                    <BSL_ColourSelector
                        tight
                        label="Colour"
                        colourList={["Match Post", "TBA", beam3.colours]}
                        value={BeamPostParameters.BeamCol3MatchBeam}
                        onChange={updateBeamPostData("BeamCol3MatchBeam")}
                        colourMatch={colourMatch}
                        style={{
                            marginTop: "-12px",
                        }}
                    />

                    {!carportMode && area_design_specs.SHAPE.DesignType === "Flat Roof" && (
                        <SegmentedButtonGroup
                            label="Number of Internal Rafters"
                            value={BeamPostParameters.NumInternalRafters}
                            tight
                            items={int_rafters_list}
                            onChange={updateBeamPostData("NumInternalRafters")}
                        />
                    )}

                    {!carportMode && area_design_specs.SHAPE.DesignType === "Flat Roof" && (
                        <BSL_CheckBox
                            tight
                            checked={BeamPostParameters.RemoveInternalRaftersWithNoPurlins}
                            returnInt
                            label="Remove Int. Rafters with no purlin load"
                            onChange={updateBeamPostData("RemoveInternalRaftersWithNoPurlins")}
                            style={{
                                marginTop: "-12px",
                            }}
                        />
                    )}
                    {area_design_specs.SHAPE.DesignType === "Pitched Roof" && (
                        <SegmentedButtonGroup
                            label="Number of Internal Rafters"
                            value={BeamPostParameters.NumExtraPortals}
                            tight
                            items={int_rafters_list}
                            onChange={updateBeamPostData("NumExtraPortals")}
                        />
                    )}
                </BSL_Common.SectionContainer>
            )}

            {beam4 && has_beam4 && (
                <BSL_Common.SectionContainer>
                    <BSL_Common.SectionHeader>
                        <div
                            className={
                                engValid && beam4_eng_result && beam4_eng_result > 0
                                    ? beam4_eng_result <= 1
                                        ? beam4_eng_result <= 0.9
                                            ? classes.header_pass
                                            : classes.header_warning
                                        : classes.header_fail
                                    : classes.header_unknown
                            }
                        >
                            <span style={{ paddingTop: "3px" }}>{beam4.Name}s</span>
                            <span style={{ marginLeft: "5px" }}>
                                {engValid && beam4_eng_result ? (
                                    beam4_eng_result <= 1 ? (
                                        <CheckCircleIcon style={{ verticalAlign: "top" }} />
                                    ) : (
                                        <CrossCircleIcon style={{ verticalAlign: "top" }} />
                                    )
                                ) : (
                                    Cached_Icon
                                )}{" "}
                            </span>
                            <span className={classes.result_item}>
                                {engValid && beam4_eng_result ? (beam4_eng_result * 100).toFixed(1) + "%" : "??.?%"}
                            </span>
                        </div>
                    </BSL_Common.SectionHeader>
                    <BSL_Select
                        style={{ flex: 1 }}
                        selectStyle={{
                            background:
                                engValid && beam4_eng_result && beam4_eng_result > 0
                                    ? beam4_eng_result <= 1
                                        ? "#99c995"
                                        : "#ff9a9a"
                                    : "#fff",
                        }}
                        value={BeamPostParameters.BeamType4}
                        tight={true}
                        items={beam4_menu_items}
                        onChange={updateBeamPostData("BeamType4")}
                        disabled={beam4_menu_items.length <= 1}
                    />
                    <BSL_ColourSelector
                        tight
                        label="Colour"
                        colourList={["Match Post", "TBA", beam4.colours]}
                        value={BeamPostParameters.BeamCol4MatchBeam}
                        onChange={updateBeamPostData("BeamCol4MatchBeam")}
                        colourMatch={colourMatch}
                        style={{
                            marginTop: "-12px",
                        }}
                    />
                </BSL_Common.SectionContainer>
            )}

            {!deckMode && !carportMode && (
                <>
                    <BSL_Button style={{ marginLeft: "8px", alignSelf: "center" }} onClick={wipeBeamMods}>
                        Reset Beam Modifications (Area)
                    </BSL_Button>
                    <SpecExtraBeamDialog areaIndex={areaIndex} />
                </>
            )}
        </div>
    );
}
